import { buildFormData, formDataHeaders } from '../../../libs/form-data.js';
import { joinUrlAndQuery, normalizeMethod } from '../../../libs/http.js';
import { Raw, objectToString } from '../../../libs/javascript.js';
/**
 * node/undici
 */
export const nodeUndici = {
    target: 'node',
    client: 'undici',
    title: 'undici',
    generate(request) {
        // Defaults
        const normalizedRequest = {
            method: 'GET',
            ...request,
        };
        // Normalization
        normalizedRequest.method = normalizeMethod(normalizedRequest.method);
        // Reset undici defaults
        const options = {
            method: normalizedRequest.method === 'GET' ? undefined : normalizedRequest.method,
        };
        // Query
        const url = joinUrlAndQuery(normalizedRequest.url ?? '', normalizedRequest.queryString);
        // Headers
        const headers = formDataHeaders(normalizedRequest);
        if (headers?.length) {
            options.headers = {};
            headers.forEach((header) => {
                options.headers[header.name] = header.value;
            });
        }
        // Cookies
        if (normalizedRequest.cookies?.length) {
            options.headers = options.headers || {};
            normalizedRequest.cookies.forEach((cookie) => {
                options.headers['Set-Cookie'] = options.headers['Set-Cookie']
                    ? `${options.headers['Set-Cookie']}; ${cookie.name}=${cookie.value}`
                    : `${cookie.name}=${cookie.value}`;
            });
        }
        // Remove undefined keys
        Object.keys(options).forEach((key) => {
            if (options[key] === undefined) {
                delete options[key];
            }
        });
        let prefix = '';
        // Add body
        if (normalizedRequest.postData) {
            if (normalizedRequest.postData.mimeType === 'multipart/form-data' && normalizedRequest.postData.params) {
                prefix = `${buildFormData(normalizedRequest.postData.params, 'node').join('\n')}\n\n`;
                options.body = new Raw('formData');
            }
            else {
                options.body = normalizedRequest.postData.text;
            }
            // JSON
            if (normalizedRequest.postData.mimeType === 'application/json') {
                options.body = new Raw(`JSON.stringify(${objectToString(JSON.parse(options.body))})`);
            }
        }
        // Transform to JSON
        const jsonOptions = Object.keys(options).length ? `, ${objectToString(options)}` : '';
        // Undici's encoder requires its own FormData class in a fresh Node process.
        const imports = prefix ? 'request, FormData' : 'request';
        // Code Template
        return `import { ${imports} } from 'undici'

${prefix}const { statusCode, body } = await request('${url}'${jsonOptions})`;
    },
};
